import { Palette } from '@mui/material';
import { FontSize } from '@store/types/UserStoreSlice.type';
import { adjustLineHeight, getTypographyVariants } from '@theme/styleOverrides/typography';

export const MuiToggleButtonGroup = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      '.MuiButtonBase-root': {
        ...getTypographyVariants(fontSize).button,
        lineHeight: `${adjustLineHeight(16, fontSize)}px`,
        borderRadius: 0,

        fontColor: palette.text.main,
        paddingRight: '10px',
        paddingLeft: '10px',
        fontWeight: 'normal',
        borderColor: palette.border.dark,

        '&.error': {
          borderColor: palette.other.error,
        },

        '&.Mui-selected': {
          fontWeight: 600,

          '&.Mui-disabled': {
            color: palette.text.disabled,
            borderColor: palette.text.disabled,
          },
        },

        '&:first-of-type': {
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
        },

        '&:last-of-type': {
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4,
        },
      },
    },
  },
});
